module.exports = __webpack_public_path__ + "static/img/LUTEIN.0a181ab1.jpg";